import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { body2Bold, colors, fontWeights, spacing, subtitle2 } from 'ui/theme';
import { useProjectAlertsContext } from '../../context';
import { useUpdatedAlertsSummary } from './useUpdatedAlertsSummary';

const SummaryList = styled.ul`
  list-style-type: disc;
`;

const StatusLabel = styled.div`
  ${body2Bold}
`;

const ChangesLabel = styled.div`
  ${subtitle2};
  font-weight: ${fontWeights.bold};
`;

const SummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.threeQuarter};
`;

const ListWrapper = styled.div`
  padding: ${spacing.threeQuarter};
  background: ${colors.backgroundSecondary};
`;

export const UPDATED_ALERTS_SUMMARY_ID = 'updated-alerts-summary';

export const UpdatedAlertsSummary = () => {
  const { allAlertMetrics } = useProjectAlertsContext();
  const {
    formState: { dirtyFields },
    getValues,
  } = useFormContext();
  const summary = useUpdatedAlertsSummary(getValues(), {
    dirtyFields,
    allAlertMetrics,
  });

  return (
    <SummaryWrapper>
      <ChangesLabel>Changes:</ChangesLabel>
      <ListWrapper data-test={UPDATED_ALERTS_SUMMARY_ID}>
        {Object.entries(summary).map(
          ([status, alertTypes]) =>
            !!alertTypes?.length && (
              <div key={status}>
                <StatusLabel>{status}</StatusLabel>
                <SummaryList>
                  {alertTypes.map((entry, idx) => (
                    <li key={`${status}-${idx}`}>{entry}</li>
                  ))}
                </SummaryList>
              </div>
            ),
        )}
      </ListWrapper>
    </SummaryWrapper>
  );
};
